module.exports = __webpack_public_path__ + "static/media/inductionIcon.aabebf15.svg";